import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import { Tag } from "primereact/tag";

interface Props {
  visible: boolean;
  onHide: () => void;
}

const HandoverRequestHistoryDialog: React.FC<Props> = ({ visible, onHide }) => {
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);

  useEffect(() => {
    if (visible) {
      fetchHistory();
    }
  }, [visible]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const data = await DeliveryCashService.getAllHandoverRequestsHistory(); // Make sure your service has this method!
      setHistory(data);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch request history",
      });
    } finally {
      setLoading(false);
    }
  };

  const amountBodyTemplate = (row: any) => row.amount?.toFixed(2);

  const requestDateBodyTemplate = (row: any) => {
    if (!row.requestDate) return "";
    return new Date(row.requestDate).toLocaleDateString("en-GB");;
  };

  const responseDateBodyTemplate = (row: any) => {
    if (!row.responseDate) return "";
    return new Date(row.responseDate).toLocaleDateString("en-GB");;
  };

  const statusBodyTemplate = (row: any) => {
  let label = "Unknown";
  let severity: "info" | "success" | "danger" = "info";

  switch (row.statusId) {
    case 6:
      label = "Sent";
      severity = "info";
      break;
    case 7:
      label = "Accepted";
      severity = "success";
      break;
    case 8:
      label = "Rejected";
      severity = "danger";
      break;
  }

  return <Tag value={label} severity={severity} />;
};

  return (
    <div className="p-2">
      <Toast ref={toast} />
      <DataTable
        value={history}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        emptyMessage="No handover request history found."
      >
        <Column field="requestSenderName" header="Sender" />
        <Column field="requestToName" header="Receiver" />
        <Column field="amount" header="Amount" body={amountBodyTemplate} />
         <Column header="Status" body={statusBodyTemplate} />
        <Column field="requestDate" header="Requested Date" body={requestDateBodyTemplate} />
        <Column field="responseDate" header="Responded Date" body={responseDateBodyTemplate} />
      </DataTable>
    </div>
  );
};

export default HandoverRequestHistoryDialog;
